// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V864","top":"styles_top__3Aho9","left":"styles_left__3Kwqr","description":"styles_description__1XBvv"};